import { Route, Routes } from "react-router-dom";
import MainLayout from "./containers/MainLayout/MainLayout";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import Login from "./containers/Login/Login";
import SelectAccessOpening from "./containers/SelectAccessOpening/SelectAccessOpening";
import { RecoverPassword } from "./containers/RecoverPassword/RecoverPassword";
import ReSendMail from "./containers/ReSendMail/ReSendMail";
import ChangePassword from "./containers/ChangePassword/ChangePassword";
import ChangePasswordSuccessScreen from "./components/ChangePassword/ChangePasswordSuccessScreen";
import InstanceMiddleware from "./components/InstanceMiddleware/InstanceMiddleware";
import Dashboard from "./containers/Dashboard/Dashboard";
import QRScanAccess from "./containers/QRScanAccess/QRScanAccess";
import CreateAccess from "./containers/CreateAccess/CreateAccess";
import ManualAccess from "./containers/ManualAccess/ManualAccess";
import { Settings } from "./containers/Settings/Settings";
import LoginCC from "./containers/LoginCC/LoginCC";
import { Reports } from "./components/Reports/Reports";
import { CreateAndEditBuilding } from "./components/Settings/BuildingManagement/CreateAndEditBuilding";
import SelectAccessBuildings from "./containers/SelectAccessBuildings/SelectAccessBuildings";
import { CreateAndEditArea } from "./components/Settings/AreasManagement/CreateAndEditArea";
import { CreateAndEditSector } from "./components/Settings/Sectors/CreateAndEditSector";
import { CreateAndEditPersonToVisit } from "./components/Settings/PeopleToVisitManagement/CreateAndEditPersonToVisit";
import { EquipmentOrToolsTypesCreateOrEdit } from "./components/Settings/EquipmentOrToolsTypes/EquipmentOrToolsTypesCreateOrEdit";

const App = () => {
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <MainLayout>
            <InstanceMiddleware>
              <Login />
            </InstanceMiddleware>
          </MainLayout>
        }
      />

      <Route
        path="*"
        element={
          <MainLayout>
            <InstanceMiddleware>
              <Login />
            </InstanceMiddleware>
          </MainLayout>
        }
      />

      <Route
        path="/login"
        element={
          <MainLayout>
            <InstanceMiddleware>
              <Login />
            </InstanceMiddleware>
          </MainLayout>
        }
      />

      <Route
        path="/loginCC/:token"
        element={
          <InstanceMiddleware>
            <MainLayout>
              <LoginCC />
            </MainLayout>
          </InstanceMiddleware>
        }
      />

      <Route
        path="/passwordHasChange"
        element={
          <MainLayout>
            <InstanceMiddleware>
              <ChangePasswordSuccessScreen />
            </InstanceMiddleware>
          </MainLayout>
        }
      />

      <Route
        path="/recoverPassword"
        element={
          <MainLayout>
            <InstanceMiddleware>
              <RecoverPassword />
            </InstanceMiddleware>
          </MainLayout>
        }
      />

      <Route
        path="/resendMail"
        element={
          <MainLayout>
            <InstanceMiddleware>
              <ReSendMail />
            </InstanceMiddleware>
          </MainLayout>
        }
      />

      <Route
        path="/resetPassword/:password_auth/:user_name"
        element={
          <MainLayout>
            <InstanceMiddleware>
              <ChangePassword />
            </InstanceMiddleware>
          </MainLayout>
        }
      />

      <Route
        path="/selectAccessOpening"
        element={
          <MainLayout>
            <PrivateRoute>
              <SelectAccessOpening />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/dashboard"
        element={
          <MainLayout className="">
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/QRScanAccess"
        element={
          <MainLayout className="">
            <PrivateRoute permissions={[1]} redirectTo="/dashboard">
              <QRScanAccess />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/manualAccess"
        element={
          <MainLayout>
            <PrivateRoute permissions={[1]} redirectTo="/dashboard">
              <ManualAccess />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/createAccess/:identificator"
        element={
          <MainLayout className="col-xl-4 col-lg-7 col-sm-9 ps-4 pe-4 mt-3">
            <PrivateRoute permissions={[1]} redirectTo="/dashboard">
              <CreateAccess />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/:param1?/:param2?/:param3?"
        element={
          <MainLayout>
            <PrivateRoute permissions={[9, 10, 11, 12]} redirectTo="/dashboard">
              <Settings />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/reports/:reportType?"
        element={
          <MainLayout className="h-100">
            <PrivateRoute permissions={[5, 6]} redirectTo="/dashboard">
              <Reports />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/selectAccessBuildings"
        element={
          <MainLayout>
            <PrivateRoute>
              <SelectAccessBuildings />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/entityManagment/buildingsMaganagement/create"
        element={
          <MainLayout className="h-100">
            <PrivateRoute permissions={[14]}>
              <CreateAndEditBuilding />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/entityManagment/buildingsMaganagement/edit/:buildingId"
        element={
          <MainLayout className="h-100">
            <PrivateRoute permissions={[14]}>
              <CreateAndEditBuilding />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/entityManagment/areasMaganagement/create"
        element={
          <MainLayout className="h-100">
            <PrivateRoute permissions={[14]}>
              <CreateAndEditArea />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/entityManagment/areasMaganagement/edit/:areaId"
        element={
          <MainLayout className="h-100">
            <PrivateRoute permissions={[14]}>
              <CreateAndEditArea />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/entityManagment/peopleToVisitMaganagement/create"
        element={
          <MainLayout className="h-100">
            <PrivateRoute permissions={[18]}>
              <CreateAndEditPersonToVisit />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/entityManagment/peopleToVisitMaganagement/edit/:personId"
        element={
          <MainLayout className="h-100">
            <PrivateRoute permissions={[18]}>
              <CreateAndEditPersonToVisit />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/entityManagment/sectorMaganagement/create"
        element={
          <MainLayout className="h-100">
            <PrivateRoute permissions={[19]}>
              <CreateAndEditSector />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/entityManagment/sectorMaganagement/edit/:sectorId"
        element={
          <MainLayout className="h-100">
            <PrivateRoute permissions={[19]}>
              <CreateAndEditSector />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/entityManagment/equipmentOrToolsMaganagement/create"
        element={
          <MainLayout>
            <PrivateRoute permissions={[20]}>
              <EquipmentOrToolsTypesCreateOrEdit />
            </PrivateRoute>
          </MainLayout>
        }
      />

      <Route
        path="/settings/entityManagment/equipmentOrToolsMaganagement/edit/:equipmentOrToolId"
        element={
          <MainLayout>
            <PrivateRoute permissions={[20]}>
              <EquipmentOrToolsTypesCreateOrEdit />
            </PrivateRoute>
          </MainLayout>
        }
      />

    </Routes>
  );
}

export default App;
